import * as _ from 'lodash';
import createSelector from 'selectorator';

import type { BuildWithRevision } from '../../types';

const getCurrentBuild = (state, props) => state.builds.builds[props.id];
const getBuilds = createSelector(['builds.builds']);
const getBuildsList = createSelector([getBuilds], _.values);

const BuildSelectors = {
  getCurrentBuild,
  getStatus: createSelector(['builds.status']),
  getBuildCount: createSelector(['builds.counts'], counts => counts.count),
  getBuildCountStatus: createSelector(['builds.counts'], counts => counts.status),
  getCurrentRevisionBuilds: (revisionLocator: string) => createSelector(
    [getBuildsList], (builds: BuildWithRevision[]) => {
      return builds.filter(build => build.locator === revisionLocator);
    }),
  getCurrentProjectBuilds: (projectLocator: string) => createSelector(
    [getBuildsList], (builds: BuildWithRevision[]) => {
      return builds
        .filter(build => build.revision?.projectId === projectLocator)
        // SORT is required here for FE
        .sort((a, b) => b.id - a.id);
    }),
};

export default BuildSelectors;
